import React from 'react';

const ListItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <li style={{ fontSize: 13, color: '#333', lineHeight: 1.8, paddingLeft: 4 }}>
    - &nbsp;{children}
  </li>
);

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    fontFamily: "'Segoe UI', Arial, sans-serif",
    backgroundColor: '#fff',
    minHeight: '100vh',
    padding: '24px 20px',
    boxSizing: 'border-box',
    maxWidth: 480,
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20,
  },
  dash: {
    fontSize: 18,
    fontWeight: 700,
    color: '#111',
    marginRight: 12,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    color: '#111',
    margin: 0,
  },
  body: {
    paddingLeft: 4,
  },
  intro: {
    fontSize: 13,
    color: '#111',
    marginBottom: 14,
    lineHeight: 1.6,
  },
  text: {
    fontSize: 13,
    color: '#333',
    marginBottom: 12,
    lineHeight: 1.7,
    textAlign: 'justify',
  },
  email: {
    fontSize: 13,
    fontWeight: 600,
    color: '#111',
    marginBottom: 12,
  },
  emailLink: {
    color: '#111',
    textDecoration: 'none',
  },
};

const ReportProblemPage: React.FC = () => {
  return (
    <div style={styles.container}>
      {/* <div style={styles.header}>
        <span style={styles.dash}>—</span>
        <h2 style={styles.title}>Report a problem</h2>
      </div> */}

      <div style={styles.body}>
        <p style={styles.intro}>
          Experiencing an issue within the app?<br />
          We're here to help.
        </p>

        <p style={styles.text}>
          If you encounter a technical error, account issue, advertisement problem, or any unexpected behavior,
          please contact us via email with the relevant details.
        </p>

        <p style={styles.text}>To help us resolve your issue faster, please include:</p>

        <ul style={{ paddingLeft: 0, listStyle: 'none', marginBottom: 14 }}>
          <ListItem>A clear description of the problem</ListItem>
          <ListItem>Your account name or registered email</ListItem>
          <ListItem>The ad link (if applicable)</ListItem>
          <ListItem>A screenshot, if available</ListItem>
        </ul>

        <p style={styles.email}>
          Email:{' '}
          <a href="mailto:support@fesilah.com" style={styles.emailLink}>
            support@fesilah.com
          </a>
        </p>

        <p style={styles.text}>
          Our support team will review your message and respond as soon as possible.
        </p>

        <p style={styles.text}>Thank you for helping us improve Fesilah.</p>
      </div>
    </div>
  );
};

export default ReportProblemPage;
